import ModelService from './ModelService';
const modelService = new ModelService();

const model = 'logs';

export async function IndexLogsAdmin() {
  return modelService.IndexModel(`${model}`);
}
